import styled from "styled-components";

export const TitleSwotItem = styled.div<{ color: string }>`
  width: 100%;
  background: ${(props) => props.color};
  color: #fff;
  font-size: 0.9rem;
  padding: 10px;
`;

export const WrapperSwotItems = styled.div`
  width: 100%;
  margin-bottom: 1rem;
  li.list-component-header{
    margin-top: 0px;
  }
`;



